import type { CSSProperties, ReactNode } from "react";
import styles from "../file/FilePage.module.css";
import { Icon } from "../Icon.tsx";
import ui from "../ui.module.css";

const hueOf = (seed: string) => {
  let hash = 0;
  for (const char of seed) hash = (hash * 31 + char.charCodeAt(0)) % 360;
  return hash;
};

type AvatarProps = { seed: string; group?: boolean; owner?: boolean };

export function Avatar({ seed, group = false, owner = false }: AvatarProps) {
  return (
    <span
      className={styles.avatar}
      data-group={group || undefined}
      data-owner={owner || undefined}
      style={owner ? undefined : ({ "--hue": hueOf(seed.toLowerCase()) } as CSSProperties)}
      aria-hidden="true"
    >
      {group ? <Icon name="people" /> : seed.charAt(0).toUpperCase()}
    </span>
  );
}

type Props = {
  seed: string;
  group?: boolean;
  owner?: boolean;
  title: ReactNode;
  detail: ReactNode;
  removeLabel?: string;
  onRemove?: () => void;
};

export function PersonRow({ seed, group, owner, title, detail, removeLabel, onRemove }: Props) {
  return (
    <li className={styles.person}>
      <Avatar seed={seed} group={group} owner={owner} />
      <span className={styles.personText}>
        <span className={styles.personEmail}>{title}</span>
        <span className={styles.personRole}>{detail}</span>
      </span>
      {onRemove ? (
        <button
          type="button"
          className={ui.iconButton}
          data-variant="ghost"
          onClick={(event) => {
            // The row unmounts, so focus moves to a neighbour or the add field first.
            const row = event.currentTarget.closest("li");
            const next =
              (row?.nextElementSibling ?? row?.previousElementSibling)?.querySelector("button") ??
              row?.closest("section")?.querySelector<HTMLInputElement>('input[type="email"]');
            onRemove();
            next?.focus();
          }}
          aria-label={removeLabel}
          title="Remove"
        >
          <Icon name="close" />
        </button>
      ) : null}
    </li>
  );
}
